import { BankAccount } from "./enum";

export const bankAccountTypes = [
  BankAccount.CURRENT,
  BankAccount.JOINT,
  BankAccount.SAVING,
];
